import { render } from "./MyLoop.vue?vue&type=template&id=0a3634a0"
import script from "./MyLoop.vue?vue&type=script&lang=js"
export * from "./MyLoop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__